import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";
import Select from 'react-select'

import helper_funcs from "../../../../helper_funcs.js";

// Validation schema
const UserEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters"),
});
export function EditUserForm({
  user,
  btnRef,
  saveUser,
}) {
  const [pushNotification, setPushNotification] = useState(false)
  const [url, setUrl] = useState('')
  const [signurl, setSignUrl] = useState('')
  var [isloading, setIsLoading] = useState(false);
  
  const changeHandler = event => {
    setPushNotification(event.value)
  };

  const fileSelected = async (event,item) => {
    document.getElementById('icon').click();
    document.getElementById('icon').onchange = async (e) => {
      setIsLoading(true)
      document.getElementById('user_image').style.display = "none"

      if(!(item.profile_image==='null' || item.profile_image==null || item.profile_image===''))
      {
        await helper_funcs.deleteImage(item.profile_image)
      }
      const upload = await helper_funcs.uploadimage(e,item,'icon')
      if(upload==='error')
      {
        return alert("Please choose a file to upload first.");
      }
      var promise = upload.promise();
    
      promise.then(
        function(data) {
          setUrl(data.key)
          document.getElementById('user_image').style.display = "block"
          document.getElementById('user_image').src = data.Location
          document.getElementById('form-submit-user').click();
          setIsLoading(false)
        },
        function(err) {
          setIsLoading(false)
          return err;
        }
      );
    }
  } 
  useEffect(() => {
    var sign_url=''
    if((user.profile_image==="")||(user.profile_image===null))
    {
      document.getElementById('user_image').style.display = "none"
    }
    if(user.profile_image)
    {
      document.getElementById('user_image').style.display = "block"
      sign_url =   helper_funcs.get_signed_url(user.userid ,user.profile_image)
    }
    setUrl(user.profile_image)
    setSignUrl(sign_url)
    setIsLoading(false)
  }, [user]);

  const formattedUser = {
    ...user,
    password: "",
    grace_period_start: user.grace_period_start ? String(user.grace_period_start).split('T')[0] : "",
    grace_period_end: user.grace_period_end ? String(user.grace_period_end).split('T')[0] : "",
  };

 return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={formattedUser}
        validationSchema={UserEditSchema}
        onSubmit={(values) => {
          let edit_user_object = values
          edit_user_object= Object.assign({selected: false}, edit_user_object);
          edit_user_object.push_notification = pushNotification
          edit_user_object.profile_image = url
          saveUser(edit_user_object);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Form className="form form-label-right" id="user_edit_form" >
              <div className="form-group row">
                <div className="col-lg-4">
                  <Field
                    name="name"
                    component={Input}
                    placeholder="name"
                    label="Name"
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    name="email"
                    component={Input}
                    placeholder="email"
                    label="Email"
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    type="number"
                    name="phone_number"
                    component={Input}
                    placeholder="phone number"
                    label="Phone number"
                  />
                </div>

              </div>
              <div className="form-group row">
                <div className="col-lg-6">
                  <Field
                    type="password"
                    name="password"
                    component={Input}
                    placeholder="Enter new password (min 6 characters)"
                    label="Change Password"
                  />
                  <span className="form-text text-muted font-size-xs">
                    Leave blank to keep existing password.
                  </span>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg-6">
                  <Field
                    type="date"
                    name="grace_period_start"
                    component={Input}
                    placeholder="Grace Period Start"
                    label="Grace Period Start"
                  />
                </div>
                <div className="col-lg-6">
                  <Field
                    type="date"
                    name="grace_period_end"
                    component={Input}
                    placeholder="Grace Period End"
                    label="Grace Period End"
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg-4">
                  <label>Push Notification</label>
                  <Select
                    closeMenuOnSelect={false}
                    options={[
                      { value: false, label: 'Not Allowed' },
                      { value: true, label: 'Allowed' }
                    ]}
                    name="push_notification"
                    onChange={event => changeHandler(event)}
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    id="icon"
                    hidden
                    name="icon"
                    type="file"
                    component={Input}
                    accept="image/*"
                  />
                  <label>Upload Icon</label>
                  <button type="button" onClick={event => fileSelected(event,user)} className="form-control btn btn-secondary" >Upload Icon</button>
               </div>

                <div className="col-lg-4">
                  {
                    (isloading)? <div className="spinner spinner-lg spinner-success" />:''
                  }
                  <img src={signurl} alt="user_image" id="user_image" style={{width: "60px", padding: "0.1rem" } } />
                
               </div>  
              </div>

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
